import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { Accordion } from '../components/Accordion';
import { BonusCard } from '../components/BonusCard';
import { ShieldCheck, Star, AlertCircle, CheckCircle2, HeartPulse, Leaf } from 'lucide-react';
export const SalesPage = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-white font-sans text-gray-800 selection:bg-[#FF8C00] selection:text-white" data-id="element-24">
      {/* SECTION 1: STICKY ANNOUNCEMENT BAR */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#1A1A1A] text-[#FFD700] text-center py-2 px-4 shadow-md flex flex-col sm:flex-row items-center justify-center gap-2 text-sm sm:text-base font-bold tracking-wide" data-id="element-25">
        <span data-id="element-26">🚨 ÚLTIMOS 12 CUPOS CON 80% DE DESCUENTO DISPONIBLES</span>
      </div>

      {/* SECTION 2: HERO */}
      <section className="relative pt-24 md:pt-20 lg:min-h-[90vh] flex items-center" data-id="element-27">
        {/* Split Background for Desktop */}
        <div className="absolute inset-0 flex flex-col md:flex-row z-0" data-id="element-28">
          <div className="w-full md:w-1/2 bg-[#FFFAF0] h-full" data-id="element-29"></div>
          <div className="w-full md:w-1/2 bg-white h-full" data-id="element-30"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 lg:gap-20 items-center py-16 md:py-24" data-id="element-31">
          <div className="space-y-8" data-id="element-32">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 text-[#FF8C00] font-semibold text-sm tracking-wide uppercase" data-id="element-33">
              <HeartPulse className="w-4 h-4" data-id="element-34" />
              Salud Digestiva Natural
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-950 leading-tight" data-id="element-35">
              Cómo Desinflamar tu Colon en 48 Horas y Recuperar tu Vientre Plano
              Naturalmente.
            </h1>
            <div className="text-xl md:text-2xl text-gray-700 leading-relaxed font-light border-l-4 border-[#008080] pl-6 py-2" data-id="element-36">
              <p className="font-medium text-gray-900" data-id="element-37">Detente un segundo…</p>
              <p className="mt-2" data-id="element-38">
                ¿Cuántas veces has tenido que cambiarte de ropa antes de salir
                porque tu vientre parece de 5 meses de embarazo?
              </p>
              <p className="mt-2" data-id="element-39">
                Mírate al espejo. Eso que sientes… no es normal. Y no… tampoco
                es "solo gases". Es una señal de auxilio.
              </p>
            </div>
            <div className="pt-4" data-id="element-40">
              <CTAButton text="¡SÍ, QUIERO DESINFLAMAR MI COLON AHORA!" onClick={scrollToPricing} data-id="element-41" />
              <p className="mt-4 text-sm text-gray-500 flex items-center gap-2" data-id="element-42">
                <ShieldCheck className="w-4 h-4 text-[#008080]" data-id="element-43" />
                Garantía de 7 días. Pago 100% seguro.
              </p>
            </div>
          </div>
          <div className="relative mx-auto w-full max-w-md md:max-w-full" data-id="element-44">
            <div className="absolute inset-0 bg-[#008080] rounded-3xl transform rotate-3 opacity-10" data-id="element-45"></div>
            <img src="https://cdn.magicpatterns.com/uploads/jjrPueZMsSiv8frgopuEMu/portada_ebook_colon.png" alt="Libro Método Colon Feliz" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl transform transition-transform hover:-translate-y-2 duration-500" data-id="element-46" />
          </div>
        </div>
      </section>

      {/* SECTION 3: LA VERDAD OCULTA & DOLOR */}
      <section className="py-24 md:py-32 bg-gray-50" data-id="element-47">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12" data-id="element-48">
          {/* Premium Box 1: Verdad Oculta */}
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-[0_8px_30px_rgba(0,0,0,0.04)] border border-gray-100 relative overflow-hidden" data-id="element-49">
            <div className="absolute top-0 left-0 w-2 h-full bg-[#FF8C00]" data-id="element-50"></div>
            <p className="text-xl md:text-2xl text-gray-800 leading-relaxed font-medium" data-id="element-51">
              Durante años te dijeron que comieras "más saludable"…
            </p>
            <p className="text-lg text-gray-600 mt-4" data-id="element-52">
              Más fibra. Más ensaladas. Más avena. Y sin darte cuenta… empezaste
              a empeorar.
            </p>
            <div className="mt-8 bg-orange-50 p-6 rounded-2xl" data-id="element-53">
              <p className="text-lg text-gray-900 font-medium" data-id="element-54">
                Porque lo que nadie te explicó es esto: <br data-id="element-55" />
                <br data-id="element-56" />
                <span className="text-[#FF8C00] font-bold text-xl" data-id="element-57">
                  👉 Un colon inflamado no necesita más fibra… necesita alivio
                  inteligente.
                </span>
              </p>
            </div>
            <p className="text-lg text-gray-800 mt-6 font-semibold" data-id="element-58">
              Y aquí es donde todo cambia.
            </p>
          </div>

          {/* Premium Box 2: Dolor y Fraccionamiento */}
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-[0_8px_30px_rgba(0,0,0,0.04)] border border-gray-100" data-id="element-59">
            <p className="text-xl text-gray-800 leading-relaxed mb-6" data-id="element-60">
              Sabes exactamente de qué hablo…
            </p>
            <p className="text-lg text-gray-600 mb-6" data-id="element-61">
              Te despiertas ligera… te miras al espejo… te sientes bien… Y luego
              comes.
            </p>
            <p className="text-xl text-gray-900 font-bold mb-6" data-id="element-62">
              Y en menos de una hora… todo se arruina.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-63">
              <li className="flex items-start gap-3" data-id="element-64">
                <AlertCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-65" />
                <span className="text-lg text-gray-700" data-id="element-66">
                  Presión. Inflamación. Ese botón que ya no cierra.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-67">
                <AlertCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-68" />
                <span className="text-lg text-gray-700" data-id="element-69">
                  Esa incomodidad silenciosa en público.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-70">
                <AlertCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-71" />
                <span className="text-lg text-gray-700" data-id="element-72">
                  Esa vergüenza que no dices… pero sientes.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-73">
                <AlertCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-74" />
                <span className="text-lg text-gray-700 font-medium" data-id="element-75">
                  Es cancelar planes a última hora porque te sientes enorme. Es
                  sentirte atrapada en tu propio cuerpo.
                </span>
              </li>
            </ul>

            <div className="py-6" data-id="element-76">
              <img src="https://cdn.magicpatterns.com/uploads/8RPTNKp3HTy3Uitdxx18Yt/Antes_y_despues_colon.png" alt="Antes y después de la inflamación del colon" className="w-full h-auto rounded-2xl shadow-md" data-id="element-77" />
            </div>

            <div className="bg-red-50 p-6 rounded-2xl mt-8 border border-red-100" data-id="element-78">
              <p className="text-xl text-red-800 font-bold mb-2" data-id="element-79">
                El verdadero enemigo no eres tú.
              </p>
              <p className="text-lg text-gray-800" data-id="element-80">
                Nos han vendido una mentira. La industria de los "falsos
                saludables" te ha convencido de que comer lechuga cruda, avena
                procesada y productos "fit" llenos de edulcorantes es la
                solución. Pero para un colon lastimado, eso es como frotar una
                herida abierta con papel lija.
              </p>
            </div>

            <p className="text-lg text-gray-800 font-medium mt-8" data-id="element-81">
              Y lo peor… Has intentado TODO.
            </p>
            <p className="text-lg text-gray-600 mt-4" data-id="element-82">
              Jugos verdes… probióticos… dietas… Y por un momento parece
              mejorar… pero siempre vuelve. Más fuerte. Más frustrante.
            </p>
            <p className="text-xl text-gray-900 font-bold mt-8 text-center italic" data-id="element-83">
              Y en el fondo… empiezas a preguntarte:
              <br data-id="element-84" />
              "¿Y si esto ya no tiene solución?"
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 3.5: AUTORIDAD Y ORIGEN */}
      <section className="py-24 bg-white" data-id="element-85">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86">
          <div className="bg-[#FFFAF0] p-8 md:p-12 rounded-3xl shadow-lg border border-orange-100 relative overflow-hidden" data-id="element-87">
            <div className="absolute top-0 right-0 w-24 h-24 bg-[#FF8C00] rounded-bl-full opacity-10" data-id="element-88"></div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-89">
              "Yo también estuve exactamente donde estás tú..."
            </h2>
            <div className="space-y-4 text-lg text-gray-700 leading-relaxed" data-id="element-90">
              <p data-id="element-91">Hola. Sé lo que se siente porque lo viví en carne propia.</p>
              <p data-id="element-92">
                Pasé años yendo de médico en médico. Me decían:{' '}
                <em data-id="element-93">"Es estrés, relájate"</em> o{' '}
                <em data-id="element-94">"Toma esta pastilla de por vida"</em>. Llegué a tener miedo
                de comer. Mi autoestima estaba en el suelo porque ninguna ropa
                me quedaba bien después de las 2 de la tarde.
              </p>
              <p data-id="element-95">
                Hasta que, por pura desesperación, empecé a investigar cómo
                sanaban el intestino nuestras abuelas en Latinoamérica. Y casi
                por accidente, descubrí un patrón.
              </p>
              <p className="font-bold text-gray-900" data-id="element-96">
                No se trataba de dejar de comer. Se trataba de darle un
                "reinicio" biológico al colon usando alimentos específicos que
                ya tenemos en nuestra cocina.
              </p>
              <p data-id="element-97">
                Cuando lo probé en mí, mi vientre se desinflamó en 48 horas.
                Pensé que era casualidad. Luego lo probaron mis amigas... y
                ocurrió el mismo milagro. Así nació este método.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4: REFRAME & MICRO TRANCE */}
      <section className="py-24 md:py-32 bg-[#FFFAF0]" data-id="element-98">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12" data-id="element-99">
          {/* Reframe Box */}
          <div className="text-center space-y-8" data-id="element-100">
            <h2 className="text-4xl md:text-6xl font-extrabold text-gray-900" data-id="element-101">
              No.
            </h2>
            <p className="text-2xl text-gray-800 font-medium" data-id="element-102">
              Escucha esto con atención:
            </p>
            <div className="bg-white p-8 md:p-12 rounded-3xl shadow-lg border-2 border-[#008080] transform -rotate-1" data-id="element-103">
              <p className="text-2xl md:text-3xl font-bold text-[#008080] mb-6" data-id="element-104">
                👉 Tu colon no está fallando. Está reaccionando. Defendiéndose.
              </p>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-105">
                De años de alimentos equivocados… de combinaciones que lo
                irritan… de "hábitos saludables"… que nunca fueron diseñados
                para ti.
              </p>
              <p className="text-xl text-gray-900 font-bold mt-8" data-id="element-106">
                Y cuando entiendes esto… dejas de luchar contra tu cuerpo. Y
                empiezas a trabajar con él.
              </p>
            </div>
          </div>

          {/* Micro Trance Box */}
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-[0_8px_30px_rgba(0,0,0,0.04)] border border-gray-100 mt-16" data-id="element-107">
            <Leaf className="w-12 h-12 text-[#008080] mb-6" data-id="element-108" />
            <p className="text-2xl text-gray-900 font-medium mb-6" data-id="element-109">
              Ahora imagina esto…
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-110">
              Solo 48 horas. Dos días. Empiezas a comer diferente… no menos… no
              con restricciones absurdas… solo diferente.
            </p>
            <p className="text-xl text-gray-800 font-medium mb-6" data-id="element-111">
              Sientes menos presión… menos ruido… menos inflamación…
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-6" data-id="element-112">
              Te miras al espejo… Y notas algo. Tu abdomen… más plano. Tu
              cuerpo… más ligero.
            </p>
            <div className="bg-green-50 p-6 rounded-2xl border border-green-100" data-id="element-113">
              <p className="text-xl text-[#008080] font-bold text-center italic" data-id="element-114">
                Respiras profundo… Y por primera vez en mucho tiempo… no hay
                tensión. Solo calma.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5: MECANISMO & FUTURE PACING */}
      <section className="py-24 md:py-32 bg-white" data-id="element-115">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
          <div className="text-center mb-16" data-id="element-117">
            <p className="text-xl text-gray-500 uppercase tracking-widest font-bold mb-4" data-id="element-118">
              El Método
            </p>
            <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6" data-id="element-119">
              Esto es lo que llamamos:
              <br data-id="element-120" />
              <span className="text-[#FF8C00]" data-id="element-121">Digestibilidad Progresiva</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-122">
            <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100" data-id="element-123">
              <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-124">
                Un método diseñado para:
              </h3>
              <ul className="space-y-4" data-id="element-125">
                <li className="flex items-center gap-3" data-id="element-126">
                  <CheckCircle2 className="w-6 h-6 text-[#008080]" data-id="element-127" />
                  <span className="text-lg text-gray-700" data-id="element-128">
                    Reducir irritación intestinal
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-129">
                  <CheckCircle2 className="w-6 h-6 text-[#008080]" data-id="element-130" />
                  <span className="text-lg text-gray-700" data-id="element-131">
                    Restaurar tu microbiota
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-132">
                  <CheckCircle2 className="w-6 h-6 text-[#008080]" data-id="element-133" />
                  <span className="text-lg text-gray-700" data-id="element-134">
                    "Reiniciar" tu digestión en tiempo récord
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-8 rounded-3xl border border-gray-100 flex flex-col justify-center" data-id="element-135">
              <p className="text-xl text-gray-900 font-bold mb-4" data-id="element-136">
                ¿Por qué funciona tan rápido?
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-4" data-id="element-137">
                Es simple lógica biológica. En lugar de bombardear tu intestino
                con fibra dura que lo raspa, usamos alimentos específicos (como
                la papaya y la calabaza) que actúan como un "bálsamo".
              </p>
              <p className="text-lg text-gray-700 leading-relaxed" data-id="element-138">
                Le damos a tu sistema digestivo un descanso absoluto mientras lo
                nutrimos, permitiendo que la pared intestinal se desinflame
                naturalmente en 48 horas.
              </p>
              <p className="text-xl text-[#008080] font-bold mt-6" data-id="element-139">
                Solo el mapa correcto.
              </p>
            </div>
          </div>

          {/* Secuencia Irrefutable (Día 1, Día 2) */}
          <div className="mb-16" data-id="element-140">
            <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-141">
              Lo que experimentarás exactamente:
            </h3>
            <div className="grid md:grid-cols-3 gap-6" data-id="element-142">
              <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-[#FF8C00]" data-id="element-143">
                <p className="text-xl font-bold text-[#FF8C00] mb-2" data-id="element-144">
                  Día 1: El Alivio
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-145">
                  Tu sistema digestivo entra en reposo. La pesadez después de
                  comer desaparece casi por completo y los gases se reducen
                  drásticamente. Sientes que tu estómago por fin "respira".
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-[#008080]" data-id="element-146">
                <p className="text-xl font-bold text-[#008080] mb-2" data-id="element-147">
                  Día 2: El Vientre Plano
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-148">
                  La pared intestinal se desinflama profundamente. Te
                  despiertas, te miras al espejo y tu abdomen está visiblemente
                  más plano. Esa ropa que te apretaba vuelve a quedarte holgada.
                </p>
              </div>
              <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-gray-900" data-id="element-149">
                <p className="text-xl font-bold text-gray-900 mb-2" data-id="element-150">
                  Día 3+: La Libertad
                </p>
                <p className="text-gray-700 leading-relaxed" data-id="element-151">
                  Tu energía se dispara porque ya no la gastas intentando
                  digerir irritantes. Vuelves a comer sin miedo y recuperas la
                  confianza de salir sin pensar en dónde hay un baño.
                </p>
              </div>
            </div>
          </div>

          {/* Future Pacing Premium Box */}
          <div className="bg-[#1A1A1A] text-white p-8 md:p-16 rounded-3xl shadow-2xl relative overflow-hidden" data-id="element-152">
            <div className="absolute top-0 right-0 w-32 h-32 bg-[#FF8C00] rounded-bl-full opacity-20" data-id="element-153"></div>
            <h3 className="text-2xl md:text-4xl font-bold mb-8 text-[#FFD700]" data-id="element-154">
              Ahora imagina tu próxima semana…
            </h3>
            <div className="space-y-6 text-lg md:text-xl text-gray-300 font-light" data-id="element-155">
              <p data-id="element-156">Te levantas… tu abdomen sigue plano.</p>
              <p data-id="element-157">
                Sales sin preocuparte por qué vas a comer. Te sientas en un
                restaurante… tranquila.
              </p>
              <p data-id="element-158">Sin ansiedad. Sin miedo. Sin incomodidad.</p>
              <p className="text-white font-medium" data-id="element-159">
                Tu ropa vuelve a quedarte como antes. Tu energía regresa. Tu
                confianza también.
              </p>
              <p className="text-2xl text-[#FFD700] font-bold pt-6 border-t border-gray-700" data-id="element-160">
                Y todo empezó… con una decisión simple.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6: PRUEBA SOCIAL */}
      <section className="py-24 md:py-32 bg-gray-50" data-id="element-161">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
          <div className="text-center mb-16" data-id="element-163">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-164">
              Personas como tú… ya están sintiendo el cambio.
            </h2>
            <div className="flex flex-wrap justify-center gap-4 text-lg font-medium text-[#008080]" data-id="element-165">
              <span className="bg-teal-50 px-4 py-2 rounded-full" data-id="element-166">
                👉 Menos inflamación en 48h
              </span>
              <span className="bg-teal-50 px-4 py-2 rounded-full" data-id="element-167">
                👉 Más energía en días
              </span>
              <span className="bg-teal-50 px-4 py-2 rounded-full" data-id="element-168">
                👉 Libertad al comer otra vez
              </span>
            </div>
            <p className="text-xl text-gray-900 font-bold mt-8" data-id="element-169">
              Y lo más importante… Recuperan control.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-170">
            {/* Testimonial 1 - Historia Detallada */}
            <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 relative md:col-span-2" data-id="element-171">
              <div className="flex text-[#FF8C00] mb-4" data-id="element-172">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-173" />)}
              </div>
              <p className="text-lg md:text-xl text-gray-700 italic mb-6 leading-relaxed" data-id="element-174">
                "Llevaba 3 años cancelando cenas con mi esposo. Me daba terror
                comer fuera porque sabía que a los 20 minutos mi panza iba a
                parecer un globo y el dolor me iba a doblar. Probé probióticos
                carísimos, dejé el gluten, los lácteos... y nada. Estaba
                desesperada.
                <br data-id="element-175" />
                <br data-id="element-176" />
                Cuando probé la Digestibilidad Progresiva, el primer día sentí
                un alivio raro, como si mi estómago por fin 'respirara'. Al
                segundo día, me puse unos jeans que no usaba desde 2021. Lloré
                frente al espejo. No es solo bajar la panza, es recuperar mi
                vida y mi matrimonio."
              </p>
              <div className="flex items-center gap-4" data-id="element-177">
                <div className="w-14 h-14 bg-[#008080] rounded-full flex items-center justify-center text-white font-bold text-2xl shadow-md" data-id="element-178">
                  C
                </div>
                <div data-id="element-179">
                  <h4 className="font-bold text-gray-900 text-lg" data-id="element-180">
                    Claudia M.
                  </h4>
                  <p className="text-sm text-gray-500 font-medium" data-id="element-181">
                    México, 38 años
                  </p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="bg-white p-8 rounded-3xl shadow-lg border border-gray-100 relative md:col-span-2 max-w-3xl mx-auto w-full" data-id="element-182">
              <div className="flex text-[#FF8C00] mb-4" data-id="element-183">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-184" />)}
              </div>
              <p className="text-lg text-gray-700 italic mb-6" data-id="element-185">
                "El dolor era constante. Este método me enseñó que estaba
                desayunando veneno. Hoy me despierto con energía y sin ruidos en
                la panza. ¡Gracias!"
              </p>
              <div className="flex items-center gap-4" data-id="element-186">
                <div className="w-12 h-12 bg-[#FF8C00] rounded-full flex items-center justify-center text-white font-bold text-xl" data-id="element-187">
                  A
                </div>
                <div data-id="element-188">
                  <h4 className="font-bold text-gray-900" data-id="element-189">Andrés R.</h4>
                  <p className="text-sm text-gray-500" data-id="element-190">Colombia, 45 años</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7: BONUSES (OFERTA) */}
      <section className="py-24 md:py-32 bg-[#FFFAF0]" data-id="element-191">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
          <div className="text-center mb-12" data-id="element-193">
            <p className="text-xl text-[#FF8C00] font-bold mb-4 uppercase tracking-widest" data-id="element-194">
              La Oferta
            </p>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-195">
              Hoy puedes acceder al método completo…
            </h2>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto" data-id="element-196">
              Más 4 guías adicionales que complementan el método principal y te
              ayudan a implementarlo más fácil, más rápido y con más claridad.
            </p>
          </div>

          <div className="space-y-6" data-id="element-197">
            <BonusCard title="Bono #1: 21 Desayunos Energéticos" description="Empieza el día con recetas simples, suaves y prácticas para sentirte con más energía y menos pesadez." value="Valor normal: $27 USD" image="https://cdn.magicpatterns.com/uploads/cZtPeoMBBemc1uySL4WHzd/heylloyd-image-1776469561913.png" data-id="element-198" />
            <BonusCard title="Bono #2: Cenas Ligeras 'Vientre Plano'" description="Opciones reconfortantes y fáciles de digerir para terminar el día sintiéndote más ligera." value="Valor normal: $27 USD" image="https://cdn.magicpatterns.com/uploads/5xKJ8K3kNzaFsC1NUh9GfT/heylloyd-image-1776469573965.png" data-id="element-199" />
            <BonusCard title="Bono #3: Antojos Inteligentes: Guía de Postres Amigables" description="Disfruta ideas dulces más ligeras sin sentir que tienes que renunciar a todo." value="Valor normal: $27 USD" image="https://cdn.magicpatterns.com/uploads/2MW2ApRdB6dzraNPh3HbEs/heylloyd-image-1776469569129.png" data-id="element-200" />
            <BonusCard title="Bono #4: Lista Maestra de Compras Inteligentes" description="Entra al mercado sabiendo exactamente qué comprar para empezar sin complicarte ni gastar de más." value="Valor normal: $17 USD" image="https://cdn.magicpatterns.com/uploads/uQzf2rRdnX9r3ryWkC9DyU/heylloyd-image-1776469578865.png" data-id="element-201" />
          </div>

          <div className="mt-12 bg-white border-2 border-[#008080] rounded-3xl p-8 md:p-10 text-center shadow-xl relative overflow-hidden" data-id="element-202">
            <div className="absolute top-0 left-0 right-0 bg-[#008080] text-white py-2 text-xs md:text-sm font-bold tracking-widest uppercase" data-id="element-203">
              Resumen de tu Oferta
            </div>
            <div className="pt-6 space-y-3" data-id="element-204">
              <p className="text-lg md:text-xl text-gray-500 font-medium line-through decoration-red-400 decoration-2" data-id="element-205">
                Valor real: $145 USD
              </p>
              <p className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-206">
                Pero hoy… no pagas eso. Ni siquiera cerca.
              </p>
              <p className="text-xl text-gray-700 mt-2" data-id="element-207">
                Hoy los recibes{' '}
                <span className="text-[#FF8C00] font-bold" data-id="element-208">GRATIS</span> con tu
                compra
              </p>
              <div className="pt-6 pb-2" data-id="element-209">
                <p className="text-sm text-gray-500 uppercase tracking-wide font-semibold mb-1" data-id="element-210">
                  Precio Final Hoy
                </p>
                <p className="text-6xl font-extrabold text-[#008080]" data-id="element-211">
                  $6.39{' '}
                  <span className="text-2xl text-gray-500 font-medium" data-id="element-212">
                    USD
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8: PRICING & URGENCY */}
      <section id="pricing-section" className="py-24 md:py-32 bg-white" data-id="element-213">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-214">
          <div className="bg-[#FFFAF0] border-2 border-[#FF8C00] rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-215">
            <div className="absolute top-0 right-0 bg-[#FF8C00] text-white text-sm font-bold px-4 py-1 rounded-bl-lg" data-id="element-216">
              OFERTA LIMITADA
            </div>
            <p className="text-2xl text-gray-700 font-medium mb-4" data-id="element-217">
              ACCESO COMPLETO HOY POR SOLO:
            </p>
            <div className="flex justify-center items-baseline gap-2 mb-8" data-id="element-218">
              <span className="text-6xl md:text-8xl font-extrabold text-gray-900" data-id="element-219">
                $6.39
              </span>
              <span className="text-2xl text-gray-500 font-medium" data-id="element-220">USD</span>
            </div>

            <div className="flex justify-center mb-8" data-id="element-221">
              <CTAButton text="¡SÍ, QUIERO DESINFLAMAR MI COLON AHORA!" href="https://pay.hotmart.com/H105419209E" className="w-full md:w-auto md:px-12 py-5 text-xl md:text-2xl" data-id="element-222" />
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-gray-600 font-medium" data-id="element-223">
              <span className="flex items-center gap-2" data-id="element-224">
                <ShieldCheck className="w-5 h-5 text-[#008080]" data-id="element-225" /> Pago Seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-226">
                <CheckCircle2 className="w-5 h-5 text-[#008080]" data-id="element-227" /> Acceso
                Inmediato
              </span>
              <span className="flex items-center gap-2" data-id="element-228">
                <Star className="w-5 h-5 text-[#008080]" data-id="element-229" /> Garantía 7 Días
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 9: FAQ */}
      <section className="py-24 md:py-32 bg-gray-50" data-id="element-230">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16" data-id="element-232">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-2" data-id="element-233">
            <Accordion question="¿Necesito comprar ingredientes caros?" answer="No. Todo se encuentra en el mercado de tu barrio (papa, calabaza, pollo, frutas locales). El método está diseñado específicamente para la realidad de Latinoamérica." data-id="element-234" />
            <Accordion question="¿Es apto para vegetarianos?" answer="Sí, el método incluye opciones claras para adaptar las proteínas sin perder la efectividad del protocolo desinflamatorio." data-id="element-235" />
            <Accordion question="¿En cuánto tiempo veré resultados?" answer="La mayoría de las personas reporta menos gases y una desinflamación visible en las primeras 48 horas de aplicar la 'Digestibilidad Progresiva'." data-id="element-236" />
            <Accordion question="¿Qué pasa si no me funciona?" answer="Tienes garantía total. Si en 7 días no sientes ligereza y alivio, te devolvemos el 100% de tu dinero sin hacer preguntas." data-id="element-237" />
          </div>
        </div>
      </section>

      {/* SECTION 10: GUARANTEE */}
      <section className="py-24 md:py-32 bg-white" data-id="element-238">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-239">
          <div className="border-4 border-[#008080] rounded-3xl p-8 md:p-16 bg-teal-50/30 relative" data-id="element-240">
            <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-white p-4 rounded-full border-4 border-[#008080]" data-id="element-241">
              <ShieldCheck className="w-12 h-12 text-[#008080]" data-id="element-242" />
            </div>
            <div className="text-center mt-6 space-y-6" data-id="element-243">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-244">
                Garantía de Satisfacción de 7 Días
              </h2>
              <p className="text-xl text-gray-700 leading-relaxed" data-id="element-245">
                Prueba el método, cocina las recetas y siente los resultados. Si
                no estás 100% feliz con tu transformación, te devuelvo cada
                centavo sin preguntas. <strong data-id="element-246">El riesgo es todo mío.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 11: FINAL CLOSE (COMANDO SUBCONSCIENTE) */}
      <section className="py-24 md:py-32 bg-gray-900 text-white" data-id="element-247">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-12" data-id="element-248">
          <h2 className="text-3xl md:text-5xl font-bold leading-tight" data-id="element-249">
            Y aquí es donde decides…
          </h2>

          <div className="bg-gray-800 p-8 md:p-12 rounded-3xl border border-gray-700 text-left max-w-2xl mx-auto" data-id="element-250">
            {/* Micro-Tensión Final */}
            <div className="mb-10 pb-8 border-b border-gray-700" data-id="element-251">
              <p className="text-xl text-gray-300 leading-relaxed mb-4" data-id="element-252">
                Imagina que estamos a 6 meses en el futuro. Si cierras esta
                página ahora, ¿qué habrá cambiado?
              </p>
              <p className="text-xl text-gray-400 leading-relaxed italic" data-id="element-253">
                Seguirás comprando ropa más grande. Seguirás sintiendo ese dolor
                punzante después de almorzar. Seguirás sintiéndote prisionera en
                tu propio cuerpo.
              </p>
            </div>

            <p className="text-xl text-gray-300 leading-relaxed mb-6" data-id="element-254">
              Puedes seguir probando cosas al azar… esperando que algo funcione…
            </p>
            <p className="text-2xl text-white font-bold mb-8" data-id="element-255">
              O puedes hacer lo que una parte de ti ya sabe que tiene sentido.
              👇
            </p>

            <div className="flex justify-center mb-8" data-id="element-256">
              <CTAButton text="¡SÍ, QUIERO EL MÉTODO COLON FELIZ + TODOS LOS BONOS!" href="https://pay.hotmart.com/H105419209E" className="w-full md:w-auto md:px-10 py-6 text-xl" data-id="element-257" />
            </div>

            <div className="text-center space-y-4 mt-8" data-id="element-258">
              <p className="text-2xl text-white font-bold" data-id="element-259">
                Recupera el control.
              </p>
              <p className="text-xl text-gray-300" data-id="element-260">
                Deja de luchar contra tu cuerpo.
              </p>
              <p className="text-2xl text-[#FFD700] font-extrabold" data-id="element-261">
                Vuelve a sentirte tú.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-950 py-12 border-t border-gray-800" data-id="element-262">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-263">
          <p className="text-gray-500 text-sm mb-4" data-id="element-264">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa de salud.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-265">
            <a href="#" className="hover:text-white transition-colors" data-id="element-266">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-267">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-268">
              Contacto
            </a>
          </div>
          <p className="text-gray-600 text-xs mt-8" data-id="element-269">
            &copy; {new Date().getFullYear()} Método Colon Feliz. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
};